export default "__VITE_ASSET__2f5b3b32__"